import angular from 'angular';
import template from './template.html';
import './style.scss';

export class EditEmailList {
    candidatesEmailList = [];

    onEmailListChange(selectedCandidateEmails, candidateEmailList) {
        this.onCandidateEmailListChanged({
            candidateEmailList: {
                ...candidateEmailList,
                selected: selectedCandidateEmails,
            }
        });
    }
}

export const EditEmailListConfiguration = {
    template,
    controller: EditEmailList,
    bindings: {
        candidatesEmailList: '<',
        onCandidateEmailListChanged: '&',
    },
    controllerAs: 'editEmailListCtrl',
};

angular.module('TALENYA-FE').component('editEmailList', EditEmailListConfiguration);
